import React, { Component, PropTypes } from 'react';
import Select from 'react-virtualized-select';

export default class EmailField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle() {
    this.props.onToggle();
    this.props.updateSettings();
  }

  onChange(value) {
    this.props.onChange(value);
    this.props.updateSettings();
  }

  render() {
    const {
      shouldShow, id, notification, frequencies, checked, value,
    } = this.props;

    if (!shouldShow) {
      return null;
    }

    return (<div className="row">
      <div className="small-16 medium-offset-3 medium-8 column">
        <div className="checkbox">
          <input
            onChange={this.onToggle}
            type="checkbox"
            className="form-control"
            checked={checked}
            id={`email-${id}`}
          />
          <label htmlFor={`email-${id}`} className="form-label">
            { notification.desc }
          </label>
        </div>
      </div>
      <div className="medium-5 medium-offset-0 column">
        { checked && <div>
          <div className="frequency-label">Frequency</div>
          <span className="tag tag-default tag-sm">
            <Select
              onChange={this.onChange}
              options={frequencies}
              value={value}
              clearable={false}
              searchable={false}
              simpleValue={true}
            />
          </span>
        </div> }
      </div>
    </div>);
  }
}

EmailField.propTypes = {
  shouldShow: PropTypes.bool,
  checked: PropTypes.bool,
  id: PropTypes.string,
  value: PropTypes.number,
  notification: PropTypes.shape({
    user_type: PropTypes.arrayOf(PropTypes.string),
    desc: PropTypes.string,
  }),
  frequencies: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })),
  onToggle: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  updateSettings: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./account/components/email_field.jsx